import { useState } from 'react';
import api from '../services/api';
import Button from '../components/Button';
import Input from '../components/Input';
import Select from '../components/Select';
import LookupSelect, { LookupOption } from '../components/LookupSelect';

const fetchEmployeeOptions = async (search: string): Promise<LookupOption[]> => {
  const res = await api.get('/employees');
  const employees = res.data.employees || [];
  const filtered = search ? employees.filter((e: any) => e.full_name.toLowerCase().includes(search.toLowerCase())) : employees;
  return filtered.slice(0, 20).map((e: any) => ({ value: e.id, label: `${e.full_name} (${e.code})` }));
};

const fetchLeaveTypeOptions = async (search: string): Promise<LookupOption[]> => {
  const res = await api.get('/lms/leave-types');
  const types = res.data.leaveTypes || [];
  const filtered = search ? types.filter((t: any) => t.name.toLowerCase().includes(search.toLowerCase())) : types;
  return filtered.map((t: any) => ({ value: t.id, label: `${t.name} (${t.code})` }));
};

export default function ApplyOnBehalf() {
  const [form, setForm] = useState({
    employeeId: '', leaveTypeId: '', fromDate: '', toDate: '', applicationType: 'FULL_DAY', reason: '',
  });

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await api.post('/lms/leave-applications/on-behalf', form);
      alert('Submitted');
      setForm({ employeeId: '', leaveTypeId: '', fromDate: '', toDate: '', applicationType: 'FULL_DAY', reason: '' });
    } catch (err: any) {
      alert(err.response?.data?.message || 'Failed to submit');
    }
  };

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-2">Apply on Behalf</h1>
      <p className="text-sm text-gray-500 mb-6">
        Only available to the selected employee's assigned 1st/2nd/Final level approver. Applying as the Final level approver auto-approves immediately.
      </p>
      <form onSubmit={submit} className="bg-white rounded-lg shadow p-6 space-y-4 max-w-2xl">
        <LookupSelect label="Employee" value={form.employeeId} onChange={(v) => setForm({ ...form, employeeId: v })} fetchOptions={fetchEmployeeOptions} required />
        <LookupSelect label="Leave Type" value={form.leaveTypeId} onChange={(v) => setForm({ ...form, leaveTypeId: v })} fetchOptions={fetchLeaveTypeOptions} required />
        <div className="grid grid-cols-2 gap-4">
          <Input label="From Date" type="date" value={form.fromDate} onChange={(e) => setForm({ ...form, fromDate: e.target.value })} required />
          <Input label="To Date" type="date" value={form.toDate} onChange={(e) => setForm({ ...form, toDate: e.target.value })} required />
        </div>
        <Select label="Application Type" value={form.applicationType} onChange={(e) => setForm({ ...form, applicationType: e.target.value })}
          options={[{ value: 'FULL_DAY', label: 'Full Day' }, { value: 'HALF_DAY', label: 'Half Day' }]} />
        <Input label="Reason" value={form.reason} onChange={(e) => setForm({ ...form, reason: e.target.value })} />
        <Button type="submit">Submit on Behalf</Button>
      </form>
    </div>
  );
}
